import React from 'react';
import LearnCalMain from "../function-components/LearningCalendar/LearnCalMain"

function LearningCalendarPage() {
    
        return (
            <>
               <LearnCalMain /> 
            </>
        );
    }

export default LearningCalendarPage;